module.exports = __webpack_public_path__ + "static/media/selfGouache.b225c371.png";